import React from 'react'

export default function ExamForms() {
  return (
    <div className='text-danger h4 p-5'>
        No Yet Release. You will be Notified on Exam Form Released.
    </div>
  )
}
